import { useCallback, useEffect, useState } from "react";
import { getEvents } from "../../../../services/StudentPortal/StudentEventService";
import { useStudentSession } from "../../context/StudentSessionContext";
import { unwrapList } from "../../utils/studentPortalUtils";
import { parseEventStartDate } from "../../utils/studentEventUtils";
import { handleApiError } from "../../../../utils/errorHandler";

// Same student/event endpoint the Dashboard ("Upcoming Events") and
// Attendance ("Holidays") already use — this page just shows the full list
// (holidays included) instead of splitting/filtering it, sorted soonest
// first using the same date-range parsing those two features rely on.
export const useStudentEvents = () => {
  const { student } = useStudentSession();
  const studentId = student?.id;
  const programId = student?.student_program?.program_id;
  const sessionId = student?.student_program?.session_id;

  const [events, setEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchEvents = useCallback(async () => {
    if (!studentId) {
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    try {
      const response = await getEvents({ student_id: studentId, program_id: programId, session_id: sessionId });
      const sorted = unwrapList(response)
        .map((event) => ({ event, date: parseEventStartDate(event) }))
        .sort((a, b) => (a.date || 0) - (b.date || 0))
        .map(({ event }) => event);
      setEvents(sorted);
    } catch (error) {
      handleApiError(error);
      setEvents([]);
    } finally {
      setIsLoading(false);
    }
  }, [studentId, programId, sessionId]);

  useEffect(() => {
    fetchEvents();
  }, [fetchEvents]);

  return { events, isLoading };
};

export default useStudentEvents;
